const roleDisplayNameMap = {
  LSP: "Local Team",
  "Local Service Partner": "Local Team",
  "Local Service Partners": "Local Teams",
  LSPs: "Local Teams",
};

/**
 * Transform a role/owner name for display
 * @param {string} roleName - The role name to transform
 * @returns {string} - The transformed display name
 */
export const transformRoleDisplayName = (roleName) => {
  if (!roleName || typeof roleName !== "string") return roleName;

  // Check for exact matches first
  if (roleDisplayNameMap[roleName]) {
    return roleDisplayNameMap[roleName];
  }

  // Replace partial matches within the string
  let result = roleName;

  // Replace "Local Service Partners" before "Local Service Partner" to avoid partial replacement
  result = result.replace(/Local Service Partners/g, "Local Teams");
  result = result.replace(/Local Service Partner/g, "Local Team");
  result = result.replace(/LSPs/g, "Local Teams");
  result = result.replace(/\bLSP\b/g, "Local Team"); // Word boundary to match whole word only

  return result;
};
